// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GEi8","question":"styles_question__1hI_P","description":"styles_description__1-ee_"};